import React from "react";
import { IGlossaryIconModel } from "../models/glossary-icons-block-models";

interface IProps {
    glossaryIcon: IGlossaryIconModel
}
const GlossaryIcon = (props: IProps) => {
    return (
      
            <a href={props.glossaryIcon.iconLink} className="glossary-block-icon">
                {props.glossaryIcon.iconImageUrl && 
                    <img src={props.glossaryIcon.iconImageUrl} alt={props.glossaryIcon.iconName} />}
            <span className="glossary-block-icon-title">{props.glossaryIcon.iconName}</span>
            </a>
            
        
    )
}

export default GlossaryIcon